import { render, staticRenderFns } from "./DependencyView.vue?vue&type=template&id=66f5779e"
import script from "./DependencyView.vue?vue&type=script&lang=js"
export * from "./DependencyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports